import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {AutoplayEvents} from '@gongxigames/framework/slot/modules/autoplay/AutoplayEvents';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad/UIDisableReason';
import {BuyBonusButtonView} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonView';
import {BuyBonusButtonModule} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonModule';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {BigWinModule} from '@gongxigames/framework/slot';

export class BuyBonusButtonAutoPlayState extends ModuleState<BuyBonusButtonView, BuyBonusButtonModule> {
    public onEnterState(): void {
        this.view.disableButton();
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(AutoplayEvents.STOP_AUTOPLAY, this.onStopAutoPlay.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(LogicEvents.SPIN_RESPONSE, this.onSpinResponseReceived.bind(this));
    }

    protected onSpinResponseReceived(): void {
        if (this.module.logic.nextAction === Action.SPIN && this.isBigWinNext()) {
            this.module.disableByName(BigWinModule.NAME);
        }
    }

    protected onReelsSpinningStarted(): void {
        this.module.disableByName(UIDisableReason.SPINNING);
    }

    protected onStopAutoPlay(): void {
        if (this.module.logic.nextAction === Action.SPIN) {
            this.module.gotoState(BuyBonusButtonModule.BASIC_STATE);
        } else {
            this.module.gotoState(BuyBonusButtonModule.FEATURE_STATE);
        }
    }

    protected isBigWinNext(): boolean {
        return this.module.logic.getWin() >= this.module.logic.getBigWinLimit();
    }
}
